import * as THREE from 'three';
import { makeSD150Panel } from '../scene/rails';
import { box } from '../scene/products';
import { applyMetricUVs } from '../scene/materialGeometry';
import { sd150Layout } from './sd150Layout';
import { sd150TrackProfile } from './sd150TrackProfile';
import { panelPositionsAt } from './stackLayout';
import { dividerArray } from './dividerArray';
import { runMeasurements } from './runMeasurements';
import { makeSlidingHandle, positionSlidingHandle } from '../scene/slidingHandle';

export function makeSD150Custom(design, materials, frame) {
  const group = new THREE.Group(), layout = sd150Layout(design), height = design.height_in * .0254;
  const { width, count, panelWidth, depth, pocket } = layout;
  for (const type of ['sill', 'head']) {
    const rail = sd150TrackProfile(count, type, width + pocket, height, frame, materials);
    rail.position.x = -pocket / 2; group.add(rail);
  }
  for (const x of [-width / 2 - pocket + .022, width / 2 - .022]) {
    for (const z of [-depth / 2 + .001, depth / 2 - .001]) box(group, .044, height, .002, x, height / 2, z, frame);
    box(group, .003, height, depth, x + (x < 0 ? -.02 : .02), height / 2, 0, frame);
  }
  if (pocket) {
    for (const z of [-1, 1]) box(group, pocket, height + .08, .06, -width / 2 - pocket / 2, (height + .08) / 2, z * (depth / 2 + .04), materials.wall);
    box(group, pocket, .08, depth + .14, -width / 2 - pocket / 2, height + .04, 0, materials.wall);
  }
  // Share the real SD150 sash template across all panels; never substitute MT.
  const template = makeSD150Panel(panelWidth, height, frame, materials.glass, materials.steel, materials);
  applyMetricUVs(template); template.updateMatrixWorld(true);
  const batches = [], translation = new THREE.Matrix4(), matrix = new THREE.Matrix4();
  template.traverse(part => {
    if (!part.isMesh) return;
    const mesh = new THREE.InstancedMesh(part.geometry, part.material, count);
    mesh.instanceMatrix.setUsage(THREE.DynamicDrawUsage); mesh.castShadow = part.castShadow; mesh.receiveShadow = true;
    group.add(mesh); batches.push({ mesh, local: part.matrixWorld.clone() });
  });
  const handle = makeSlidingHandle({ system: 'SD150', panelWidth, panelHeight: height, pocket: !!pocket, panelIndex: count - 1 }, materials); group.add(handle);
  const bars = dividerArray(group, count, panelWidth, height, design.dividers, frame, { glassWidth: panelWidth - .068, glassHeight: height - .142, glassCenterY: .097 + (height - .142) / 2 });
  const animate = fraction => {
    const positions = panelPositionsAt(layout, fraction);
    for (const { mesh, local } of batches) {
      positions.forEach(({ x, z }, i) => { translation.makeTranslation(x, 0, z); matrix.multiplyMatrices(translation, local); mesh.setMatrixAt(i, matrix); });
      mesh.instanceMatrix.needsUpdate = true; mesh.computeBoundingSphere(); mesh.computeBoundingBox();
    }
    positionSlidingHandle(handle, positions[count - 1]);
    bars(positions); group.userData.panelPositions = positions;
  };
  const measures = runMeasurements(width, height, design.run_a.width_in, false, 'a'); group.add(measures);
  animate(design.openings.a / 100); applyMetricUVs(group);
  return { group, runs: [{ group, measures, animate, screen: null, width, height, panelWidth, count, tracks: count, depth, side: 'a', layout }] };
}